import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getLiteraryDesignUnitVisual } from "../../data/visuals";

import type { PropertyValues } from "lit";
import type { LiteraryDesignUnitVisualData } from "../../types.d";

@customElement("bp-viz-ephesians-literary-design-unit")
export class EphesiansLiteraryDesignUnit extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin: var(--size-2) 0;
    }

    .container {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  `;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: LiteraryDesignUnitVisualData;

  @property({ attribute: "debug" })
  debug?: boolean;

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getLiteraryDesignUnitVisual(this.arcId)
      .then(({ data }) => {
        console.log("data", data);
        this.data = { ...data };
        if (data.usx) {
          const parser = new DOMParser();
          const usx = parser.parseFromString(`${data.usx}`, "text/xml");
          this.data = { ...data, usx: usx.documentElement.outerHTML };
        }
      })
      .catch(() => undefined);
  }

  render() {
    if (!this.data) return;

    const { usx, html: designHTML, caption } = this.data;

    if (usx?.length) {
      return html`
        <bp-literary-design>
          <script type="text/xml">
            ${usx}
          </script>

          ${caption &&
          html`
            <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption>
          `}
        </bp-literary-design>
      `;
    } else {
      return html`
        <div class="container">
          ${this.debug
            ? html`<bp-ephesians-literary-design debug .data=${designHTML} />`
            : html`<bp-ephesians-literary-design .data=${designHTML} />`}
        </div>
        ${caption &&
        html` <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption> `}
      `;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-ephesians-literary-design-unit": EphesiansLiteraryDesignUnit;
  }
}
